/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Search_Near_MeInputs */

const en_directory_search_near_me = /** @type {(inputs: Directory_Search_Near_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Near me`)
};

const pl_directory_search_near_me = /** @type {(inputs: Directory_Search_Near_MeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W pobliżu`)
};

/**
* | output |
* | --- |
* | "Near me" |
*
* @param {Directory_Search_Near_MeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const directory_search_near_me = /** @type {((inputs?: Directory_Search_Near_MeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Search_Near_MeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_directory_search_near_me(inputs)
	return en_directory_search_near_me(inputs)
});